const TOAST_CONTAINER_ID = "app-toast-container";

const typeToBorderClass = {
  info: "border-info",
  success: "border-success",
  warning: "border-warning",
  error: "border-error",
  notice: "border-success",
  alert: "border-error"
};

const ensureContainer = () => {
  let container = document.getElementById(TOAST_CONTAINER_ID);

  if (container) return container;

  container = document.createElement("div");
  container.id = TOAST_CONTAINER_ID;
  // DaisyUI "stack" keeps notifications contained (no upward growth).
  container.className = "stack fixed top-4 right-4 z-50 w-[calc(100vw-2rem)] max-w-xs sm:w-96 pointer-events-auto";

  document.body.appendChild(container);

  return container;
};

const createCard = (message, type) => {
  const card = document.createElement("div");
  const borderClass = typeToBorderClass[type] || typeToBorderClass.info;
  card.className = `card relative shadow-md bg-base-100 border border-base-300 border-l-4 ${borderClass}`;
  card.setAttribute("data-controller", "flash");
  card.setAttribute("role", "alert");
  card.innerHTML = `
    <div class="card-body p-3">
      <button type="button"
              class="btn btn-ghost btn-xs absolute top-0 right-0 w-8 h-8 min-h-0 p-0 leading-none"
              aria-label="Dismiss notification"
              data-action="click->flash#dismissAll"><span class="text-xs">x</span></button>
      <div class="text-xs leading-snug break-words pr-5">${message}</div>
    </div>
  `;
  return card;
};

const showToast = (message, { type = "info", duration = 5000 } = {}) => {
  const container = ensureContainer();
  const card = createCard(message, type);

  // Prepend so the newest item sits on top of the stack
  container.insertAdjacentElement("afterbegin", card);

  if (duration > 0) {
    setTimeout(() => {
      card.classList.add("opacity-0", "transition-opacity", "duration-500");
      setTimeout(() => card.remove(), 500);
    }, duration);
  }

  return card;
};

export const showError = (message, options = {}) =>
  showToast(message, { type: "error", ...options });

export const showInfo = (message, options = {}) =>
  showToast(message, { type: "info", ...options });

export const showSuccess = (message, options = {}) =>
  showToast(message, { type: "success", ...options });

export const showWarning = (message, options = {}) =>
  showToast(message, { type: "warning", ...options });

export default showToast;
